import { createContext, useContext } from "react";

const ProjectTemplateContext = createContext({});

export const ProjectTemplateContextProvider = ProjectTemplateContext.Provider;
export const ProjectTemplateContextConsumer = ProjectTemplateContext.Consumer;

export const useProjectTemplateContext = () => useContext(ProjectTemplateContext);

export default ProjectTemplateContext;
